export const changeFavicon = (iconName) => {
    const link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");
    link.type = "image/png";
    link.rel = "icon";
  
    // Example: public/icons/Diwali.png or public/icons/default.png
    link.href = `/icons/${iconName}.png`;
  
    document.head.appendChild(link);
  };